import ProjectNamePanel from './ProjectNamePanel'

export default ProjectNamePanel
